import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IIntegrationErrorData } from "common/records/IntegrationError";

export const RECEIVE_INTEGRATION_ERRORS = "@integrationError/RECEIVE_INTEGRATION_ERRORS";

export const IntegrationErrorActions = {
  receiveIntegrationErrors: (errors: IIntegrationErrorData[]) => createAction(RECEIVE_INTEGRATION_ERRORS, errors),
};

export type IntegrationErrorActions = ActionsUnion<typeof IntegrationErrorActions>;
